import React from 'react'
import ApiIntegrationSettings from '../integrationsettings/apiIntegrationSettings'

const AdminApiIntegration = () => {
    return (
        <ApiIntegrationSettings />
    )
}

export default AdminApiIntegration